import ReactHTMLTableToExcel from "react-html-table-to-excel";
//components
import Reportes from "./Reportes";

const Boleteria = ({
  evento,
  reportes,
  onClick,
  onChange,
  rol,
  campos,
  extra,
}) => {
  return (
    <>
      <div className="container-md texto-normal" style={{ maxWidth: "3000px" }}>
        <div className="row">
          <div class="col-md-12 col-12 mb-3 d-md-flex d-block">
            <h1 className="me-md-2 fs-3 text-muted">BOLETERIA</h1>
            <h1 className="fs-3">{evento?.nombre}</h1>
            <div
              className="bg-white p-3 text-center me-md-2 d-none"
              style={{ borderRadius: "20px" }}
            >
              <div className="d-block fw-bold text-muted text-nowrap">
                TOTAL DE VENTAS
              </div>
              <div>
                <span className="fs-6">ARS</span> 0
              </div>
            </div>

            <div
              className="bg-white p-3 text-center me-2 d-none"
              style={{ borderRadius: "20px" }}
            >
              <div className="d-block fw-bold text-muted text-nowrap">
                TOTAL DE ENTRADAS
              </div>
              <div> 0 </div>
            </div>
          </div>

          <div className="col-md-4 col-12 mb-3">
            <div class="input-group ">
              <input
                type="text"
                class="form-control fs-6 p-0 px-2 py-2"
                style={{ borderRadius: "10px" }}
                name="search"
                onChange={(event) => onChange(event)}
              />
              <button
                class="input-group-text fs-6 px-2 p-0 border-0 bg-transparent text-dark"
                id="basic-addon2"
              >
                <i class="bi bi-search"></i>
              </button>
            </div>
          </div>

          <div className="col-md-4 col-12 mb-3">
            <select
              class="form-select fs-9 p-0 fs-6 px-2 py-2"
              style={{ borderRadius: "10px" }}
              aria-label="Default select example"
              name="fecha"
              onChange={(event) => onChange(event)}
            >
              <option selected>Selecciona una fecha</option>
              {evento
                ? evento.fechasJSON.map((fecha) => (
                    <option value={fecha.fechas[0] + " HORA: " + fecha.hora}>
                      {fecha.fechas[0] + " Hora: " + fecha.hora}
                    </option>
                  ))
                : ""}
            </select>
          </div>

          <div className="col-md-4 col-12 mb-3">
            <select
              class="form-select fs-9 p-0 fs-6 px-2 py-2"
              style={{ borderRadius: "10px" }}
              aria-label="Default select example"
              name="status"
              onChange={(event) => onChange(event)}
            >
              <option selected>Seleccionar estado</option>
              <option value="TODOS">Todos</option>
              <option value="ACTIVO">Activos</option>
              <option value="REEMBOLSO">Reembolsados</option>
              <option value="INACTIVO">Inactivos</option>
              <option value="PAUSADO">Pausados</option>
              <option value="LIQUIDADO">Liquidados</option>
              <option value="RECHAZADO">Rechazados</option>
            </select>
          </div>

          <div className="col-md-12 col-12 mb-3">
            <label className="btn btn-outline-success me-2">
              <i class="bi bi-filetype-xls"></i>
              <ReactHTMLTableToExcel
                id="buttonDownloadExcel"
                className="d-none"
                table="boleteriaVentas"
                filename="reporteDeVentas"
                sheet="pagina 1"
                buttonText="Exportar tabla actual"
              />
            </label>

            <label className="text-center btn btn-outline-dark">
              {campos.state ? "Ver menos datos" : "Ver mas datos"}
              <button
                className="d-none"
                name="ver-mas"
                onClick={(event) => onClick(event)}
              ></button>
            </label>
          </div>

          {reportes ? (
            <div className="col-md-12">
              <Reportes
                data={reportes}
                onChange={onChange}
                onClick={onClick}
                extra={extra}
              />
            </div>
          ) : (
            ""
          )}

          <div className="d-none" id="reader"></div>
        </div>
      </div>
    </>
  );
};

export default Boleteria;
